// Fundal UNIC, full-viewport, în spatele tuturor secțiunilor. Culoarea vine din tema
// paginii (App): forest pe 'dark', bone pe 'light'. Crossfade CSS de ~1s = efectul
// de „întrerupător" al template-ului. Secțiunile Products + Services sunt transparente
// => mereu se vede o singură culoare.
export default function BgSwitch({ theme }) {
  return (
    <div
      aria-hidden
      className="fixed inset-0 -z-10"
      style={{
        backgroundColor: theme === 'light' ? '#F0EBE0' : '#1F2A24',
        transition: 'background-color 0.6s cubic-bezier(0.65, 0, 0.35, 1)',
      }}
    />
  )
}
